import React from "react";

export const IconOption7 = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.4923 11.8165C16.2304 13.9276 14.5002 15.6578 12.3891 15.9197C11.1113 16.0784 9.92084 15.7292 8.99227 15.0467C8.46053 14.6578 8.58751 13.8324 9.22243 13.6419C11.6113 12.9197 13.4923 11.0308 14.2224 8.64191C14.4129 8.01493 15.2383 7.88794 15.6272 8.41175C16.3018 9.34826 16.651 10.5387 16.4923 11.8165Z"
        fill="#F2F2F2"
      />
      <path
        d="M7.02389 0.11084C3.52389 0.11084 0.682617 2.95211 0.682617 6.45211C0.682617 9.95211 3.52389 12.7934 7.02389 12.7934C10.5239 12.7934 13.3652 9.95211 13.3652 6.45211C13.3572 2.95211 10.5239 0.11084 7.02389 0.11084ZM6.27786 5.56322L8.19055 6.22989C8.88103 6.47592 9.21436 6.96005 9.21436 7.70608C9.21436 8.56322 8.53182 9.26957 7.69849 9.26957H7.62706V9.30925C7.62706 9.63465 7.35722 9.90449 7.03182 9.90449C6.70643 9.90449 6.43659 9.63465 6.43659 9.30925V9.26163C5.55563 9.22195 4.84928 8.48386 4.84928 7.56322C4.84928 7.23782 5.11913 6.96798 5.44452 6.96798C5.76992 6.96798 6.03976 7.23782 6.03976 7.56322C6.03976 7.84894 6.24611 8.07909 6.50008 8.07909H7.69055C7.87309 8.07909 8.01595 7.91243 8.01595 7.70608C8.01595 7.4283 7.96833 7.41243 7.78579 7.34894L5.87309 6.68227C5.19055 6.44417 4.84928 5.96005 4.84928 5.20608C4.84928 4.34894 5.53182 3.64259 6.36516 3.64259H6.43659V3.61084C6.43659 3.28544 6.70643 3.0156 7.03182 3.0156C7.35722 3.0156 7.62706 3.28544 7.62706 3.61084V3.65846C8.50801 3.69814 9.21436 4.43624 9.21436 5.35687C9.21436 5.68227 8.94452 5.95211 8.61913 5.95211C8.29373 5.95211 8.02389 5.68227 8.02389 5.35687C8.02389 5.07116 7.81754 4.841 7.56357 4.841H6.37309C6.19055 4.841 6.0477 5.00767 6.0477 5.21401C6.03976 5.48386 6.08738 5.49973 6.27786 5.56322Z"
        fill="#F2F2F2"
      />
    </svg>
  );
};
